import React, { useEffect, useState } from 'react'

function ScrollButton() {
    const [scrollTop, setScrollTop] = useState(0);

    const onScroll = () => {
        const winScroll = document.documentElement.scrollTop;
        const height =
            document.documentElement.scrollHeight -
            document.documentElement.clientHeight;

        const scrolled = (winScroll / height) * 100;
        setScrollTop(scrolled);
    };

    function topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    useEffect(() => {
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <React.Fragment>
            {scrollTop == 0 ? null :
                <div className="avatar-sm mb-0 scroll-to-top-button" onClick={topFunction}>
                    <span className="avatar-title rounded-circle cursor-pointer bg-success">
                        <i className='fas fa-angle-double-up font-size-24'></i>
                    </span>
                </div>
            }


        </React.Fragment>
    )
}

export default ScrollButton
